export default __webpack_public_path__ + "static/media/loading.3c756460.gif";